import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/node_modules/fumadocs-core/dist/framework/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/fumadocs-core/dist/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AnchorProvider"] */ "/vercel/path0/node_modules/fumadocs-core/dist/toc.js");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlock","Pre"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/codeblock.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/layout/toc-clerk.js");
;
import(/* webpackMode: "eager", webpackExports: ["TOCScrollArea","TOCItems","Toc"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/components/layout/toc.js");
;
import(/* webpackMode: "eager", webpackExports: ["I18nLabel"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/contexts/i18n.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageBody","TocPopover","TocPopoverTrigger","TocPopoverContent","PageArticle","Breadcrumb","LastUpdate","Footer"] */ "/vercel/path0/node_modules/fumadocs-ui/dist/page-client.js");
